import React, { FunctionComponent, useEffect, useRef } from 'react';
import { kpiPageSelectors } from '../../../../../../app/page/page-storage/kpi/kpi.selectors';
import { useSelect } from '../../../../../../utils/selector.utils';
import { IWidgetKpiProps } from './types';
import { WidgetKpiBody } from './WidgetKpiBody';
import { WidgetKpiHeader } from './WidgetKpiHeader';

export const WidgetKpi: FunctionComponent<IWidgetKpiProps> = ({
  meetingId,
  kpisGroupedByUser,
  userId,
  height = '80vh',
}) => {
  const kpiRowIds = useSelect(kpiPageSelectors.selectKpiRowIds);

  // Automatic scroll to current date
  const tableRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // The auto-scroll logic is executed 100 milliseconds after rendering to ensure that the 'current' div element already exists and has been rendered.
    const timer = setTimeout(() => {
      const tableContainer = tableRef.current;
      const currentDateDiv = document.querySelector('.scroll-target') as HTMLElement;
      if (tableContainer && currentDateDiv) {
        // Only scroll horizontally, not vertically
        const containerRect = tableContainer.getBoundingClientRect();
        const elementRect = currentDateDiv.getBoundingClientRect();
        const scrollLeft = elementRect.left - containerRect.left + tableContainer.scrollLeft;
        tableContainer.scrollTo({ left: scrollLeft, behavior: 'smooth' });
      }
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="panel ">
      <div className="panel-body pt-0 ho-hover px-0">
        <div className="border-radius-1 lightGray-bg p-2" style={{ position: 'sticky', top: '20px' }}>
          <div className="row">
            <div className="col" style={{ paddingLeft: '0px' }}>
              <div
                ref={tableRef}
                className="table-container kpi-table"
                role="table"
                aria-label="Destinations"
                style={{ paddingLeft: '20px', paddingRight: '5px', maxHeight: height }}
              >
                <WidgetKpiHeader meetingId={meetingId} />
                <WidgetKpiBody kpiRowIds={kpiRowIds} kpisGroupedByUser={userId ? true : kpisGroupedByUser} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
